// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../../common/JQueryView';
export default class NewView extends JQueryView {
  constructor() {
    super('.change-owners-wrapper');
  }

  @on({ event: 'click', selector: '.registration-register-card' })
  onChangeRegisterCard(el: any) {
    const target = $(el.currentTarget);
    if (target.hasClass('is_active')) return;

    // 青枠の付与
    $('.registration-register-card').toggleClass('is_active');

    // 「登録する付与者」の出しわけ
    const stakeholderSelect = $('#stakeholderSelect');
    if (target.attr('id') === 'change-ownersRegistered') {
      stakeholderSelect.removeClass('d-none');
    } else {
      stakeholderSelect.addClass('d-none');
    }

    // 登録方法セット
    if ($('#registration_type').val() === 'new') {
      $('#registration_type').val('registered');
    } else {
      $('#registration_type').val('new');
    }
  }
}
